<template>
  <v-card
    outlined
    class="px-6"
  >
    <div class="d-flex flex-row justify-space-between">
      <label class="subtitle-1 pb-3 pt-1 mt-4">{{ inputName }}</label>
    </div>
    <small class="error--text">{{ errorMessages }}</small>
    <br>
    <v-card
      class="withdrawal-options mb-3"
      color="white darken-3"
      :key="i"
      v-for="(item, i) in items"
    >
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >

            <v-textarea
              outlined
              label="Checklist item"
              v-model="items[i].text"
              rows="2"
            />

          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <b
          @click="removeFAQ(i)"
          class="text-caption font-weight-bold header-btns"
        >remove</b>
      </v-card-actions>

    </v-card>
    <b
      @click="addFAQ"
      class="text-caption font-weight-bold header-btns"
    >Add Item
    </b>
  </v-card>
</template>

<script>

export default {
  name: 'TextArrayInput',
  props: {
    items: {
      type: Array,
      default () {
        return []
      }
    },
    inputName: {
      type: String,
      default: 'Checklist Items'
    },
    errorMessages: {
      type: [String, Array, Object],
      default () {
        return null
      }
    },
  },
  methods: {
    addFAQ () {
      this.items.push(
        {
          text: null
        }
      )
    },
    removeFAQ (i) {
      this.items.splice(i, 1)
    }
  }
}
</script>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.withdrawal-options {
  margin-top: 20px;
}
</style>
